import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "mb_cart_v1";

export function CartProvider({ children }) {
  // Cart: { companyId, companyName, items: [{product_id, title, unit_price, qty, image_url, cashback_pct_on_checkout}] }
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch { return null; }
  });

  useEffect(() => {
    if (cart) localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
    else localStorage.removeItem(STORAGE_KEY);
  }, [cart]);

  const itemCount = (cart?.items || []).reduce((a, b) => a + b.qty, 0);
  const subtotal = (cart?.items || []).reduce((a, b) => a + b.unit_price * b.qty, 0);

  const addItem = (companyId, companyName, product) => {
    setCart((prev) => {
      if (prev && prev.companyId !== companyId) {
        const ok = window.confirm(
          `Seu carrinho já tem itens de "${prev.companyName}". Cada pedido é por empresa.\n\n` +
          `Deseja limpar e começar um novo pedido em "${companyName}"?\n\n` +
          `(Cancelar para continuar com o pedido atual de "${prev.companyName}")`
        );
        if (!ok) return prev;
        return { companyId, companyName, items: [{ ...product, qty: 1 }] };
      }
      if (!prev) return { companyId, companyName, items: [{ ...product, qty: 1 }] };
      const existing = prev.items.find((i) => i.product_id === product.product_id);
      const items = existing
        ? prev.items.map((i) => i.product_id === product.product_id ? { ...i, qty: i.qty + 1 } : i)
        : [...prev.items, { ...product, qty: 1 }];
      return { ...prev, items };
    });
  };
  const loadFromOrder = (order) => {
    // Restaura itens de um pedido pendente para edição
    const items = (order.items || []).map((it) => ({
      product_id: it.product_id,
      title: it.title,
      unit_price: it.unit_price,
      qty: it.qty,
      image_url: it.image_url,
      cashback_pct_on_checkout: it.cashback_pct_on_checkout || 0,
      turbo_cashback_pct_on_checkout: it.turbo_pct || 0,
    }));
    setCart({ companyId: order.company_id, companyName: order.company_name, items });
  };
  const setQty = (pid, qty) => {
    setCart((prev) => {
      if (!prev) return prev;
      const items = prev.items.map((i) => i.product_id === pid ? { ...i, qty: Math.max(0, qty) } : i).filter((i) => i.qty > 0);
      if (items.length === 0) return null;
      return { ...prev, items };
    });
  };
  const removeItem = (pid) => setQty(pid, 0);
  const clear = () => setCart(null);

  return (
    <CartContext.Provider value={{ cart, itemCount, subtotal, addItem, setQty, removeItem, clear, loadFromOrder }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
